module.exports = __webpack_public_path__ + "img/ring_y_skip_null_null@2x.15fb6406.png";